import { useSEO } from "@/hooks/useSEO";
import { DirectoryPage } from "@/components/DirectoryPage";
import { useLanguage } from "@/context/LanguageContext";

const CATEGORIES = [
  "All",
  "Women",
  "Men",
  "Non-binary & Gender-Diverse",
  "New Faces",
  "Curve & Plus-Size",
  "Commercial & Lifestyle",
  "Editorial & Runway",
  "Speciality & Parts",
];

export default function Models() {
  const { t } = useLanguage();
  useSEO(
    t("nav.models") + " — Diamotims Agency",
    "High-fashion models, new faces, curve, commercial and editorial talent represented by Diamotims Agency, Montréal."
  );
  return (
    <DirectoryPage
      division="MODELS"
      eyebrow={t("models.eyebrow")}
      titleLines={[t("models.title1"), t("models.title2")]}
      intro={t("models.intro")}
      categories={CATEGORIES}
      pageTestid="models-page"
    />
  );
}
